import { render, staticRenderFns } from "./NotificacionesInfo.vue?vue&type=template&id=6c3b8704"
import script from "./NotificacionesInfo.vue?vue&type=script&lang=js"
export * from "./NotificacionesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3b8704')) {
      api.createRecord('6c3b8704', component.options)
    } else {
      api.reload('6c3b8704', component.options)
    }
    module.hot.accept("./NotificacionesInfo.vue?vue&type=template&id=6c3b8704", function () {
      api.rerender('6c3b8704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/info_procesos/NotificacionesInfo.vue"
export default component.exports